import { computed } from 'vue'

/** @typedef {import('vue').ComputedRef} ComputedRef */

/**
 * 直接获取当前环境（非响应式）
 * @returns {'dev' | 'test' | 'test2' | 'gray' | 'prod'}
 */
export const getEnv = () => {
  const currentHost = window.location.host

  // 开发环境专用
  if (process.env.NODE_ENV === 'development') {
    if (currentHost.startsWith('localhost') || currentHost.startsWith('127.0.0.1')) {
      const targetApi = process.env.TARGET_API
      if (targetApi === 'test2') return 'test2'
      if (targetApi === 'dev') return 'dev'
      return 'test'
    }
  }

  const envMap = {
    'che-dev.cheweijia.com': 'dev',
    'che-test.cheweijia.com': 'test',
    'che-test2.cheweijia.com': 'test2',
    'che-pre.cheweijia.com': 'gray',
    'che.cheweijia.com': 'prod',
  }
  return envMap[currentHost] || 'prod'
}

/**
 * 环境检测 composable
 * @returns {{ env: ComputedRef<'dev' | 'test' | 'test2' | 'gray' | 'prod'> }}
 */
export const useEnv = () => {
  const env = computed(() => getEnv())
  return { env }
}
